import { docReady } from "@libs/helpers";

/**
 * Wilderness Camp mobile subnav (see _embeds/_layouts/sidebar-page.twig).
 *
 * The subnav sits below the hero and is `position: sticky; top: 0`. Once it
 * pins, scrolling down lets it slide away 1:1 with the scroll (so it appears
 * to simply scroll off with the page) and scrolling up brings it back. When
 * it unpins at the hero it must sit exactly in the document flow again, so
 * the main site header can take over at that point.
 */

let subnav;
let sentinel;
let siteHeader;
let lastY = 0;
let hidden = 0;

const paint = () => {
	subnav.style.transform = hidden ? `translateY(${-hidden}px)` : "";
};

const scroll = () => {

	const y = Math.max(0, window.pageYOffset);
	const delta = y - lastY;
	lastY = y;

	// How far we've scrolled past the point where the subnav pins.
	// The sentinel is a zero-height, in-flow element directly above it.
	const overshoot = -sentinel.getBoundingClientRect().top;

	// offsetHeight is 0 on lg+ screens, where the subnav is display:none
	// and the sidebar handles navigation instead.
	const pinned = subnav.offsetHeight > 0 && overshoot >= 0;

	// While the dropdown panel is open, stay put — the panel hangs off
	// this element and would otherwise slide away with it.
	const dropdownOpen = subnav.querySelector('[aria-expanded="true"]');

	if (!pinned || dropdownOpen) {
		hidden = 0;
	} else {
		// Capping at the overshoot keeps the subnav in its natural flow
		// position as it first crosses the pin point, and guarantees it is
		// fully revealed again by the time it unpins, so it always docks
		// seamlessly back under the hero.
		hidden = Math.max(0, Math.min(hidden + delta, subnav.offsetHeight, overshoot));
	}

	// The pinned subnav fully covers the main header, but the two move at
	// different speeds, so the header would peek out as the subnav slides
	// away. Keep it invisible until the subnav unpins at the hero.
	if (siteHeader) {
		siteHeader.style.visibility = pinned ? "hidden" : "";
	}

	requestAnimationFrame(paint);

};

docReady(() => {

	subnav = document.querySelector("[data-sticky-subnav]");

	if (!subnav || !subnav.previousElementSibling) {
		return;
	}

	sentinel = subnav.previousElementSibling;
	siteHeader = document.getElementById("site-header");

	lastY = Math.max(0, window.pageYOffset);
	scroll();
	window.addEventListener("scroll", scroll);

});
